/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type MultiBankStatus =
  typeof MultiBankStatus[keyof typeof MultiBankStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MultiBankStatus = {
  APPROVED: 'APPROVED',
  ACTIVE: 'ACTIVE',
  ACCEPTED: 'ACCEPTED',
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  REQUESTED: 'REQUESTED',
  CLOSED: 'CLOSED',
  INTERNAL_REVIEW: 'INTERNAL_REVIEW',
  FAILED: 'FAILED',
} as const;
